import styled from "styled-components/macro";
export const StyledSignUp = styled.div`
    margin-top: 1rem;
`
export const StyledInputGroupRow = styled.div`
     display: flex;
     gap: 1rem;
     justify-content: space-between;
`;